import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { RoutePaths } from '../route-paths';
const LandingPage = lazy(() => import('../../pages'));

export const homeRoutes: RouteObject[] = [
  {
    path: RoutePaths.HOMEPAGE,
    element: <LandingPage />,
  },
];
